import type { EntryTemplate } from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"

const defaultSelector = {}

// adds "deleted_at" and "account_id" selector to entry template query
export function createEntryTemplateQueryObject(
  accountId: number,
  {
    selector,
    sort,
    limit,
  }: MangoQuery<EntryTemplate>,
): MangoQuery<EntryTemplate> {
  return {
    selector: {
      account_id: { $eq: accountId },
      deleted_at: { $eq: null },
      ...(selector ?? defaultSelector),
    },
    sort,
    limit,
  }
}
